module.exports = __webpack_public_path__ + "e3876a883db8f2847459cc904e44f44c.svg";